import { useSignal } from "@preact/signals-react"
import { capitalize } from "@mui/material"
import { userPayload } from "Pages/Admin/Users/@signals"
import { formatDate } from "@ui-seeker/utils"

export default function useAdminUsersInfo(value, key, keyField = null) {

	const dataInfo = useSignal(value)

	const setDataInfo = (value) => {
		dataInfo.value = value

		const updatedUserFormData = userPayload.peek()

		if (keyField) {
			if (key === "expirationDate") {
				updatedUserFormData[keyField][key] = formatDate(value, { format: 'yyyy-MM-dd' })
			} else {
				updatedUserFormData[keyField][key] = value
			}
		} else {
			updatedUserFormData[key] = value
		}

		userPayload.value = { ...updatedUserFormData }
	}


	return {
		[key]: dataInfo.value,
		[`set${capitalize(key)}Info`]: setDataInfo,
	}
}
